module.exports = __webpack_public_path__ + "fonts/Baloo2-Regular.6208e63.ttf";